export const SYMPTOM_LABELS = Object.freeze({
  ES: Object.freeze({
    "Cough/congestion": "Tos/congestion",
    Nausea: "Náuseas",
    "Difficulty breathing": "Dificultad para respirar",
    "Sore throat": "Dolor de garganta",
    Rash: "Erupción cutánea",
    Fever: "Fiebre",
    Chills: "Escalofríos",
    Diarrhea: "Diarrea",
    "Bleeding from body openings": "Sangrado por orificios del cuerpo",
    "Red eyes": "Ojos rojos",
    "Body aches": "Dolores corporales",
    "Discolored or bloody urine": "Orina descolorida o con sangre",
    "Loss of smell or taste": "Pérdida del olfato o del gusto",
    "Yellow skin/eyes": "Piel u ojos amarillos",
    Other: "Otro",
  }),
});

export function symptomLabel(value, lang = "EN") {
  return SYMPTOM_LABELS[lang]?.[value] || value;
}

// Several symptoms named in one phrase ("Fever + Nausea"), for copy that interpolates the
// active symptom filter. The filter ANDs its selections, so "+" reads as "and".

export function symptomListLabel(values, lang = "EN") {
  return (Array.isArray(values) ? values : [values])
    .filter((value) => typeof value === "string" && value)
    .map((value) => symptomLabel(value, lang))
    .join(" + ");
}
